import { useCallback, useState } from 'react';
import type { Update } from '#global/updates/updates.ts';
import { useUpdates } from '#hooks/useUpdates.ts';

/**
 * {@link useWhatsNewProvider} owns the panel's open state, so the entry point in the account menu
 * and the panel at the layout root do not have to be siblings.
 */
export function useWhatsNewProvider(entries?: readonly Update[]) {
  const { updates, hasUnread, markAllSeen } = useUpdates(entries);
  const [isOpen, setIsOpen] = useState(false);

  const close = useCallback(() => setIsOpen(false), []);

  // Opening is what counts as reading, so the dot clears here rather than on close — someone who
  // opens the panel and immediately leaves has still seen the headlines.
  const open = useCallback(() => {
    setIsOpen(true);
    markAllSeen();
  }, [markAllSeen]);

  return { updates, hasUnread, isOpen, open, close };
}
